import { render, staticRenderFns } from "./CollegeView.vue?vue&type=template&id=14a91930&scoped=true"
import script from "./CollegeView.vue?vue&type=script&lang=js"
export * from "./CollegeView.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/college/CollegeView.css?vue&type=style&index=0&id=14a91930&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a91930",
  null
  
)

export default component.exports